import React from 'react';

/**
 * Reusable yes/no radio group used by life-event update sections.
 *
 * @param {string} id        - Unique field id (used in radio name).
 * @param {string} label     - Visible label text.
 * @param {string} value     - 'yes' | 'no' | undefined.
 * @param {function} onChange - Called with 'yes' or 'no'.
 */
export default function YesNoRadio({ id, label, value, onChange }) {
  return (
    <div className="mb-3">
      <label className="form-label small fw-semibold">{label}</label>
      <div>
        {['yes', 'no'].map((opt) => (
          <div className="form-check form-check-inline" key={opt}>
            <input
              className="form-check-input"
              type="radio"
              id={`${id}_${opt}`}
              name={id}
              checked={value === opt}
              onChange={() => onChange(opt)}
            />
            <label className="form-check-label" htmlFor={`${id}_${opt}`}>
              {opt === 'yes' ? 'Yes' : 'No'}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
